import Rest from "@/services/api_config/RestApi";

export default {
    getVehicleLayouts(params) {
        var data = ``;
        if (
            params.limit !== null &&
            params.limit !== undefined &&
            params.limit !== ""
        ) {
            data += `&limit=${params.limit}`;
        }
        if (
            params.offset !== null &&
            params.offset !== undefined &&
            params.offset !== ""
        ) {
            data += `&offset=${params.offset}`;
        }
        if (
            params.search !== null &&
            params.search !== undefined &&
            params.search !== ""
        ) {
            data += `&search=${params.search}`;
        }
        if (
            params.order !== null &&
            params.order !== undefined &&
            params.order !== ""
        ) {
            data += `&order=${params.order}`;
        }
        if (
            params.desc !== false &&
            params.desc !== null &&
            params.desc !== undefined &&
            params.desc !== ""
        ) {
            data += `&desc=${params.desc}`;
        }
        if (
            params.company_id !== null &&
            params.company_id !== undefined &&
            params.company_id !== ""
        ) {
            data += `&company_id=${params.company_id}`;
        }
        if (
            params.sub_company_id !== null &&
            params.sub_company_id !== undefined &&
            params.sub_company_id !== ""
        ) {
            data += `&sub_company_id=${params.sub_company_id}`;
        }
        if (
            params.reservation_agent_id !== null &&
            params.reservation_agent_id !== undefined &&
            params.reservation_agent_id !== ""
        ) {
            data += `&reservation_agent_id=${params.reservation_agent_id}`;
        }
        return Rest().get("seatko/agent/vehicle-layout?" + data.substring(1));
    },
    getVehicleLayout(id) {
        return Rest().get("seatko/agent/vehicle-layout/" + id);
    },
    getVehicleType(id) {
        return Rest().get("ticketko/com/vehicle-type/" + id);
    },
    deleteVehicleLayout(id) {
        return Rest().delete("seatko/agent/vehicle-layout/" + id);
    },
    getUnassignedVehicleLayouts(params) {
        let data = ``;
        if (
            params.company_id !== null &&
            params.company_id !== undefined &&
            params.company_id !== ""
        ) {
            data += `&company_id=${params.company_id}`;
        }
        if (
            params.sub_company_id !== null &&
            params.sub_company_id !== undefined &&
            params.sub_company_id !== ""
        ) {
            data += `&sub_company_id=${params.sub_company_id}`;
        }
        if (
            params.reservation_agent !== null &&
            params.reservation_agent !== undefined &&
            params.reservation_agent !== ""
        ) {
            data += `&reservation_agent=${params.reservation_agent}`;
        }
        if (
            params.reservation_agent_id !== null &&
            params.reservation_agent_id !== undefined &&
            params.reservation_agent_id !== ""
        ) {
            data += `&reservation_agent_id=${params.reservation_agent_id}`;
        }
        return Rest().get("seatko/agent/unassigned-vehicle-layout?" + data.substring(1));
    },
    assignVehicleLayouts(params) {
        return Rest().post("seatko/agent/assign-vehicle-layout/", params);
    },
    getRoutes(params) {
        var data = ``;
        if (
            params.limit !== null &&
            params.limit !== undefined &&
            params.limit !== ""
        ) {
            data += `&limit=${params.limit}`;
        }
        if (
            params.offset !== null &&
            params.offset !== undefined &&
            params.offset !== ""
        ) {
            data += `&offset=${params.offset}`;
        }
        if (
            params.search !== null &&
            params.search !== undefined &&
            params.search !== ""
        ) {
            data += `&search=${params.search}`;
        }
        if (
            params.order !== null &&
            params.order !== undefined &&
            params.order !== ""
        ) {
            data += `&order=${params.order}`;
        }
        if (
            params.desc !== false &&
            params.desc !== null &&
            params.desc !== undefined &&
            params.desc !== ""
        ) {
            data += `&desc=${params.desc}`;
        }
        if (
            params.company_id !== null &&
            params.company_id !== undefined &&
            params.company_id !== ""
        ) {
            data += `&company_id=${params.company_id}`;
        }
        if (
            params.sub_company_id !== null &&
            params.sub_company_id !== undefined &&
            params.sub_company_id !== ""
        ) {
            data += `&sub_company_id=${params.sub_company_id}`;
        }
        if (
            params.reservation_agent_id !== null &&
            params.reservation_agent_id !== undefined &&
            params.reservation_agent_id !== ""
        ) {
            data += `&reservation_agent_id=${params.reservation_agent_id}`;
        }
        return Rest().get("seatko/agent/route?" + data.substring(1));
    },
    getRoute(id) {
        return Rest().get("seatko/agent/route/" + id);
    },
    deleteRoute(id) {
        return Rest().delete("seatko/agent/route/" + id);
    },
    getUnassignedRoutes(params) {
        let data = ``;
        if (
            params.company_id !== null &&
            params.company_id !== undefined &&
            params.company_id !== ""
        ) {
            data += `&company_id=${params.company_id}`;
        }
        if (
            params.sub_company_id !== null &&
            params.sub_company_id !== undefined &&
            params.sub_company_id !== ""
        ) {
            data += `&sub_company_id=${params.sub_company_id}`;
        }
        if (
            params.reservation_agent !== null &&
            params.reservation_agent !== undefined &&
            params.reservation_agent !== ""
        ) {
            data += `&reservation_agent=${params.reservation_agent}`;
        }
        if (
            params.reservation_agent_id !== null &&
            params.reservation_agent_id !== undefined &&
            params.reservation_agent_id !== ""
        ) {
            data += `&reservation_agent_id=${params.reservation_agent_id}`;
        }
        return Rest().get("seatko/agent/unassigned-route?" + data.substring(1));
    },
    assignRoutes(params) {
        return Rest().post("seatko/agent/assign-route/", params);
    },
};
